<template>
    <div id="contenedor-eliminar-respuesta-detalle-documento">
      <v-card>
        <v-card-title class="secondary--text"> Eliminar archivo </v-card-title>
        <v-card-text>
          <span class="secondary--text">
            ¿Desea eliminar el archvio?
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
          </custom-button>
          <custom-button
            @click="mixEliminarDetalleDocumento"
            :disabled="enviandoFormulario"
            tipo="formAceptar"
            label="Eliminar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </div>
</template>

<script>
import mixAuditoriaRespuestaDetalleDocumentos from './mixAuditoriaRespuestaDetalleDocumentos';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarDocumentoDetalleRespuesta',
  mixins: [mixAuditoriaRespuestaDetalleDocumentos],
  props: {
    detalleDocumentoEliminar: {
      type: Object,
      required: true,
    },
    idRespuesta: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

  <style lang="scss" scoped></style>
